import { CircularProgress, Grow, recomposeColor } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ButtonWithGlyphIcon from "../../PhylloConnectComponents/CommonComponents/ButtonWithGlyphIcon/ButtonWithGlyphIcon";
import Footer from "../../PhylloConnectComponents/CommonComponents/Footer/Footer";
import FullScreenLoader from "../../PhylloConnectComponents/CommonComponents/FullScreenLoader";
import NavBar from "../../PhylloConnectComponents/CommonComponents/NavBar/NavBar";
import { createUser, createUserToken } from "../../utils/apiHelper";
import { getAllAccounts } from "../../utils/apiHelperInternal";
import TwitterIcon from "@mui/icons-material/Twitter";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TikTokIcon from "../../PhylloConnectComponents/CommonComponents/TiktokIcon/TiktokIcon";
import {
  onAccountConnectedCallBack,
  onAccountDisconnectedCallBack,
  onTokenExpiredCallBack,
} from "../../utils/callbackFunctions";
import {
  PHYLLO_TOKEN,
  PHYLLO_USERID,
  PHYLLO_CONNECTED_KEY,
} from "../../utils/constants";
import "./Connect.scss";
import { checkConnection } from "../../utils/helper";

function Connect() {
  const history = useHistory();
  const [isBtnLoader, setIsBtnLoader] = useState(false);
  const [isLoader, setIsLoader] = useState(true);

  const goBack = () => {
    history.push("/");
  };

  const continueClick = async (workPlatformId) => {
    setIsBtnLoader(true);
    try {
      const environment = process.env.REACT_APP_ENV;
      const clientDisplayName = process.env.REACT_APP_PHYLLO_APP;
      const userId = sessionStorage.getItem(PHYLLO_USERID);
      let token = sessionStorage.getItem(PHYLLO_TOKEN);

      if (!userId || !token) {
        const timeStamp = new Date();
        const userId = await createUser(clientDisplayName, timeStamp.getTime());

        const token = await createUserToken(userId);
        sessionStorage.setItem("PhylloUserId", userId);
        sessionStorage.setItem("PhylloToken", token);
      }
      // const phylloConnectURL = await window.PhylloConnectSDK.clientConnect(
      //   env,
      //   userId,
      //   token,
      //   name,
      //   workPlatformId
      // );
      // window.location.href = phylloConnectURL;
      // debugger
      const config = {
        clientDisplayName,
        environment,
        userId,
        token,
        redirect: false,
        workPlatformId,
        singleAccount: true,
      };

      const onExitCallBack = (reason, userId) => {
        console.log(`onExit reason: ${reason}, userId: ${userId}`);
        setIsBtnLoader(false);
        history.go(0);
      };

      const phylloConnect = window.PhylloConnect.initialize(config);

      phylloConnect.on("exit", onExitCallBack);
      phylloConnect.on("tokenExpired", onTokenExpiredCallBack);
      phylloConnect.on("accountConnected", onAccountConnectedCallBack);
      phylloConnect.on("accountDisconnected", onAccountDisconnectedCallBack);

      phylloConnect.open();
    } catch (err) {
      console.log(err);
      setIsBtnLoader(false);
    }
  };

  const navigateToDashboard = async () => {
    const userId = sessionStorage.getItem(PHYLLO_USERID);
    // for authorization
    if (!userId) {
      history.push("/");
      return;
    }
    let token = sessionStorage.getItem(PHYLLO_TOKEN);
    if (userId && !token) {
      const userId = sessionStorage.getItem("PHYLLO_USERID");
      token = await createUserToken(userId);
      sessionStorage.setItem(PHYLLO_TOKEN, token);
      sessionStorage.setItem("PhylloToken", token);
    }
    sessionStorage.setItem("PhylloUserId", userId);

    if (!userId || !token) {
      setIsBtnLoader(false);
      setIsLoader(false);
      return;
    }
    let retry = 4;
    let accounts;

    async function retryAcc() {
      let status;
      if (retry > 0) {
        accounts = await getAllAccounts();
        status = accounts.status;
        accounts = accounts.data;
      }
      if (
        accounts &&
        accounts.data &&
        accounts.data.length &&
        Boolean(userId) &&
        checkConnection(accounts)
      ) {
        history.push("/dashboard");
        return status;
      }
      return status;
    }

    // debugger;
    async function rec(leftTries) {
      if (leftTries > 0) {
        let status = await retryAcc();
        // console.warn(status);
        if (status !== 200) {
          window.setTimeout(async () => {
            await rec(leftTries - 1);
          }, 2000);
        } else {
          setIsLoader(false);
          setIsBtnLoader(false);
          return;
        }
      } else {
        // console.warn("not executed before");
        setIsLoader(false);
        setIsBtnLoader(false);
        return;
      }
    }

    await rec(retry);
    // if (
    //   accounts &&
    //   accounts.data &&
    //   accounts.data.length &&
    //   Boolean(userId) &&
    //   checkConnection(accounts)
    // ) {
    //   history.push("/dashboard");
    // } else {
    //   setIsLoader(false);
    //   setIsBtnLoader(false);
    //   return;
    // }
    // setIsBtnLoader(false);
  };
  useEffect(() => {
    navigateToDashboard();
  }, []);
  return (
    <>
      {isLoader ? (
        <FullScreenLoader color="#2262ED" />
      ) : (
        <Grow in={true}>
          <div className="screenBackground">
            <NavBar isLightMode={true} isLoggedIn={true} history={history} />
            <div className="content-box-home" style={ isBtnLoader? {height: "calc(100vh - 250px)"}:null}>
              <div className="content-box">
                <h1 className="content-box-heading">Connect an account</h1>
                {isBtnLoader ? (
                  <CircularProgress />
                ) : (
                  <div className="connect-btns">
                    <ButtonWithGlyphIcon
                      text={"Connect YouTube"}
                      icon={<img src={"https://cdn.getphyllo.com/platforms_logo/logos/youtube_red_logo.png"} height={60} alt="YouTube" />}
                      click={() =>
                        continueClick("14d9ddf5-51c6-415e-bde6-f8ed36ad7054")
                      }
                    />
                    <ButtonWithGlyphIcon
                      text={"Connect TikTok"}
                      icon={<TikTokIcon />}
                      click={() =>
                        continueClick("de55aeec-0dc8-4119-bf90-16b3d1f0c987")
                      }
                    />
                    <ButtonWithGlyphIcon
                      text={"Connect Twitter"}
                      icon={<TwitterIcon />}
                      click={() =>
                        continueClick("7645460a-96e0-4192-a3ce-a1fc30641f72")
                      }
                    />
                    <ButtonWithGlyphIcon
                      text={"Connect other platform"}
                      icon={<AddCircleIcon />}
                      click={() => continueClick()}
                    />
                  </div>
                )}
              </div>
            </div>
            <Footer />
          </div>
        </Grow>
      )}
    </>
  );
}

export default Connect;
